module.exports = __webpack_public_path__ + "img/cloth_g1_hat_04.e2438e05.svg";